import * as React from "react"

// Bewusst dieselbe Query wie Tailwinds `md:` (48rem) statt eines Pixelwerts: `rem`
// bezieht sich in Media Queries auf die Standard-Schriftgroesse des Browsers. Mit
// `768px` driften JS- und CSS-Breakpoint auseinander, sobald der Nutzer die
// Root-Font-Size hochsetzt — dann erscheinen Sheet- und Desktop-Sidebar gleichzeitig
// oder keine von beiden. `useCalendarState` haengt an derselben Grenze.
export const MD_BREAKPOINT_QUERY = "(min-width: 48rem)"

export function useIsMobile() {
  // Lazy Initializer: ohne ihn liefert der Hook im ersten Render immer `false`
  const [isMobile, setIsMobile] = React.useState(
    () => typeof window !== "undefined" && !window.matchMedia(MD_BREAKPOINT_QUERY).matches
  )

  React.useEffect(() => {
    const mql = window.matchMedia(MD_BREAKPOINT_QUERY)
    const onChange = (event: MediaQueryListEvent) => {
      setIsMobile(!event.matches)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(!mql.matches)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
